import React from 'react';
import {paths} from '../../common/dictionaries/urls';
import PartsQueryList from './query/list';
import ViewCpdQuery from './query/view';
import ViewKardex from './kardex/';
import PartsAnalysisList from './analysis/list';
import EditPartsAnalysis from './analysis/edit';
import CodeWithoutLabels from './codesWithoutLabels';

export const partRoutes = [
  {'component': <PartsQueryList />, 'path': paths.PartsQueryList},
  {'component': <ViewCpdQuery />, 'path': paths.ViewCpdQuery},
  {'component': <ViewKardex />, 'path': paths.Kardex},
  {'component': <ViewKardex />, 'path': paths.ViewKardex},
  {'component': <PartsAnalysisList />, 'path': paths.PartsAnalysisList},
  {'component': <EditPartsAnalysis />, 'path': paths.EditPartsAnalysis},
  {'component': <CodeWithoutLabels />, 'path': paths.CodeWithoutLabels},
];
